import { createRouter, createWebHistory } from "vue-router";
import TopView from "../views/pages/TopView.vue";
import BoardView from "../views/pages/BoardView.vue";
import CompanyView from "../views/pages/CompanyView.vue";
import CompanyDetailView from "../views/pages/CompanyDetailView.vue";
import PresentationView from "../views/pages/PresentationView.vue";
import createStoreInstance from "../store/index";
import axiosPlugin from '../plugins/axiosPlugin'; 
//navigationガードのためにstoreの値の初期化を待つ
const storePromise = new Promise((resolve) => {
  resolve(createStoreInstance(axiosPlugin));
});

const routes = [
  {
    path: "/",
    name: "top",
    component: TopView,
    props: true,
    meta: { title: 'トップページ' }
  },
  {
    path: "/board",
    name: "board",
    component: BoardView,
    meta: { title: '課題解決掲示板ページ' },
  },
  {
    path: "/company",
    name: "company",
    component: CompanyView,
    meta: { title: '企業一覧ページ' },
  },
  {
    path: "/companyDetail",
    name: "companyDetail",
    component: CompanyDetailView,
    meta: { requiresAuth: true, title: '企業詳細ページ' },
  },
  {
    path: "/presentation",
    name: "presentation",
    component: PresentationView,
    meta: { title: 'プレゼンテーションページ' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // trailingSlash オプションを追加
  trailingSlash: true,
  scrollBehavior(to, from, savedPosition) {

    //もし企業ページ関連じゃなかったらスクロールポジションの履歴を消す
    if (to.name != 'company' && to.name != 'companyDetail') {
      sessionStorage.removeItem('companyScrollPosition');
    }

    //もし企業詳細ページから企業一覧へ戻る場合、もとの企業一覧でのスクロール位置へ戻す
    if (to.name == 'company' && from.name == 'companyDetail') {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({top: sessionStorage.getItem('companyScrollPosition')});
        }, 300);
      })
    }

    if (to.fullPath != '/#about') {
      if (savedPosition) {

        //もし企業詳細ページから企業一覧へ戻る場合、もとの企業一覧でのスクロール位置へ戻す
        //if (to.name == 'company' && from.name == 'companyDetail') {
        //  return new Promise((resolve, reject) => {
        //    setTimeout(() => {
        //      resolve(savedPosition);
        //    }, 300);
        //  })
        //}
        //return savedPosition;

      } else {
        return {
          top: 0
        }
      }
    }
  },
});


router.beforeEach(async (to, from, next) => {
  try {
    // Vuexストアの初期化を待機
    await storePromise;
    next();
  } catch (error) {
    next(false);
  }
});

router.afterEach((to, from) => {
  document.title = to.meta.title ? 'OTEX おかやまテクノロジー展2024 ONLINE 精鋭企業と出会う技術展示商談会 | ' + to.meta.title : 'OTEX おかやまテクノロジー展2024 ONLINE 精鋭企業と出会う技術展示商談会';
})

export default router;
